export default function CaretLeftIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#D7DFE9" />
      <path
        d="M18.06 20L19 19.06L15.9467 16L19 12.94L18.06 12L14.06 16L18.06 20Z"
        fill="#455468"
      />
    </svg>
  );
}
